import { ArrowRight } from "lucide-react";

const STAGES = [
  { k: "Visitor", d: "Curious about training" },
  { k: "Course Guidance", d: "Talk to an advisor" },
  { k: "Training Path", d: "Mapped to your role" },
  { k: "Practical Learning", d: "Live or self-paced" },
  { k: "Work Readiness", d: "Confident for projects" },
];

const THEMES = [
  "Understand tools and workflows in real enterprise context",
  "Build confidence for project conversations and reviews",
  "Learn from practical scenarios, not surface-level lectures",
  "Prepare for implementation, support, and consulting roles",
  "Upskill teams against actual business needs",
  "Improve productivity with AI tools embedded in real work",
];

export default function OutcomesJourney() {
  return (
    <section id="outcomes" className="py-6 lg:py-8 bg-bg-dark text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-grid-dark opacity-25" aria-hidden />
      <div
        className="absolute -right-32 top-1/3 h-[500px] w-[500px] rounded-full blur-3xl opacity-25"
        style={{ background: "var(--cyan)" }}
        aria-hidden
      />
      <div className="relative mx-auto max-w-[1440px] px-5 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <p className="font-mono-ui text-[11px] uppercase tracking-[0.22em] text-[var(--cyan)]">
              06 · Outcomes
            </p>
            <h2 className="font-display text-2xl md:text-3xl lg:text-[34px] font-bold mt-3 leading-[1.06] text-balance">
              Training that connects learning with{" "}
              <span style={{ color: "var(--cyan)" }}>real work.</span>
            </h2>
          </div>
        </div>

        {/* Horizontal journey */}
        <div className="mt-14 relative">
          <div className="hidden md:flex items-stretch gap-3 overflow-x-auto pb-4">
            {STAGES.map((s, idx) => (
              <div key={s.k} className="flex items-stretch gap-3 shrink-0">
                <div className="w-[220px] rounded-2xl border border-white/10 bg-white/5 backdrop-blur-md p-5">
                  <p className="font-mono-ui text-[11px] uppercase tracking-[0.22em] text-white/60">
                    Stage {idx + 1}
                  </p>
                  <h3 className="font-display text-lg font-bold mt-2 leading-tight">{s.k}</h3>
                  <p className="text-[13px] text-white/70 mt-2 leading-relaxed">{s.d}</p>
                </div>
                {idx < STAGES.length - 1 && (
                  <div className="self-center text-[var(--cyan)]">
                    <ArrowRight size={18} />
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="md:hidden space-y-3">
            {STAGES.map((s, idx) => (
              <div
                key={s.k}
                className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur-md p-5"
              >
                <p className="font-mono-ui text-[11px] uppercase tracking-[0.22em] text-white/60">
                  Stage {idx + 1}
                </p>
                <h3 className="font-display text-lg font-bold mt-2 leading-tight">{s.k}</h3>
                <p className="text-[13px] text-white/70 mt-2 leading-relaxed">{s.d}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Outcome themes */}
        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {THEMES.map((t, i) => (
            <div
              key={t}
              className="rounded-xl border border-white/10 bg-white/[0.03] p-5 hover:border-[var(--cyan)]/40 transition-colors"
            >
              <p className="font-mono-ui text-[11px] tracking-[0.18em] text-[var(--cyan)]">
                {String(i + 1).padStart(2, "0")}
              </p>
              <p className="text-[14.5px] leading-relaxed mt-2 text-white/85">{t}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
